import {FC} from 'react'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Button from 'jbc-front/components/Button'
import {Upload} from 'jbc-front/components/icons'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {FileInput} from 'jbc-front/components/presenters/form/FileInput'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'
import {asyncError} from 'store/actions/asyncError'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {useUploadGroupsCsv} from 'hooks/api/importGroupsCsv/useUploadGroupsCsv'
import styles from './FileUploadForm.scss'

// @ts-ignore
import {Consumer as AsyncTaskConsumer} from 'AsyncTask'
// @ts-ignore
import sample from '../../../../../../../../../samples/groups.csv'

type UploadCsvSchema = {
  file: File
}

type TaskRunningProps = {
  disabled?: boolean
  disabledReason?: string
}

export const FileUploadForm: FC = () => {
  const upload = useUploadGroupsCsv()
  const dispatch = useDispatch()
  const history = useHistory()

  const schema = yup.object({
    file: yup.mixed<File>().required('ファイルを選択してください'),
  })

  const {
    handleSubmit: handleReactHookFormSubmit,
    register,
    resetField,
    setValue,
    watch,
    formState: {errors},
  } = useForm<UploadCsvSchema>({
    resolver: yupResolver(schema),
    reValidateMode: 'onBlur',
  })
  const file = watch('file')

  const handleSubmit = async (data: UploadCsvSchema) => {
    try {
      await upload({file: data.file})
      history.push('/settings/groups')
    } catch (err) {
      dispatch(asyncError(err))
    }
  }

  const onDrop = (files: File[], _f: unknown, _e: unknown) => {
    if (files[0]) {
      setValue('file', files[0])
    }
  }

  const onRemoveFile = () => {
    resetField('file')
  }

  return (
    <div className={`u-mt30 ${styles.mainNoteWrap}`}>
      <div className={`u-ta-c ${styles.mainNoteTitle}`}>
        新規に登録したいグループ情報を記載したファイルを選択してください
      </div>
      <div className={styles.mainNoteBody}>
        <div className={styles.mainNote}>対応しているファイル形式はCSVとなります</div>
        <div className={styles.mainNote}>
          <a className="u-txt-link" href={sample} target="_blank" rel="noopener" download="sample.csv">
            サンプルをダウンロード
          </a>
        </div>
        <Spacer direction="y" size={20} />
        <form onSubmit={handleReactHookFormSubmit(handleSubmit)} className={styles.form}>
          <FileInput onDrop={onDrop} {...register('file')} placeholder="ファイルを選択 または ドラッグ＆ドロップ" />
          {errors.file?.message && <ErrorMessage>{errors.file.message}</ErrorMessage>}
          {file && (
            <>
              <Spacer direction="y" size={20} />
              <FileInput.File file={file} onRemove={onRemoveFile} />
            </>
          )}

          <Spacer direction="y" size={40} />
          <AsyncTaskConsumer>
            {({taskRunningProps}: {taskRunningProps: TaskRunningProps}) => (
              <Button primary widthWide onClick={handleReactHookFormSubmit(handleSubmit)} {...taskRunningProps}>
                <Upload />
                アップロード
              </Button>
            )}
          </AsyncTaskConsumer>
        </form>
      </div>
    </div>
  )
}
